/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Create_New_PasswordInputs */

const en_create_new_password = /** @type {(inputs: Create_New_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create New Password`)
};

const es_create_new_password = /** @type {(inputs: Create_New_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crear nueva contraseña`)
};

const fr_create_new_password = /** @type {(inputs: Create_New_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créer un nouveau mot de passe`)
};

const de_create_new_password = /** @type {(inputs: Create_New_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neues Passwort erstellen`)
};

const ja_create_new_password = /** @type {(inputs: Create_New_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しいパスワードを作成`)
};

const zh_create_new_password = /** @type {(inputs: Create_New_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创建新密码`)
};

const ar_create_new_password = /** @type {(inputs: Create_New_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إنشاء كلمة مرور جديدة`)
};

const id_create_new_password = /** @type {(inputs: Create_New_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buat Kata Sandi Baru`)
};

const it_create_new_password = /** @type {(inputs: Create_New_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea Nuova Password`)
};

const ru_create_new_password = /** @type {(inputs: Create_New_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Создать новый пароль`)
};

const pt_create_new_password = /** @type {(inputs: Create_New_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criar Nova Senha`)
};

const ko_create_new_password = /** @type {(inputs: Create_New_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`새 비밀번호 생성`)
};

/**
* | output |
* | --- |
* | "Create New Password" |
*
* @param {Create_New_PasswordInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const create_new_password = /** @type {((inputs?: Create_New_PasswordInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Create_New_PasswordInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_create_new_password(inputs)
	if (locale === "es") return es_create_new_password(inputs)
	if (locale === "fr") return fr_create_new_password(inputs)
	if (locale === "de") return de_create_new_password(inputs)
	if (locale === "ja") return ja_create_new_password(inputs)
	if (locale === "zh") return zh_create_new_password(inputs)
	if (locale === "ar") return ar_create_new_password(inputs)
	if (locale === "id") return id_create_new_password(inputs)
	if (locale === "it") return it_create_new_password(inputs)
	if (locale === "ru") return ru_create_new_password(inputs)
	if (locale === "pt") return pt_create_new_password(inputs)
	return ko_create_new_password(inputs)
});